export default "__VITE_ASSET__DrUwASWg__"